// extracted by mini-css-extract-plugin
export var closeButton = "_k7-2";
export var closeButtonIcon = "_k7-3";
export var lightboxContent = "_k7-1";
export var lightboxOverlay = "_k7-0";